import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";

/**
 * Renders a button which, when selected, will open a popup for login
 */
export const UserLogin = () => {
  const { instance } = useMsal();

  const buttonRef = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      buttonRef.current?.click();
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  function handleLogin(instance) {
    instance
      .loginRedirect()
      .then((response) => console.log(response))
      .catch((e) => {
        console.error(e);
      });
  }

  const style = {
    display: "none",
  };

  return (
    <button ref={buttonRef} onClick={() => handleLogin(instance)} style={style}>
      Sign in
    </button>
  );
};
